// extracted by mini-css-extract-plugin
export default {"root":"qgvRMK","paper":"DcN8i4","mobile":"pzGNwY","content":"SQ8XPv","editor":"OsaaI4","next":"fKQCFr"};